import React from 'react'
import SecondLucide from '../secondLucide'

export default function SubBenifits(props) {
  return (
    <div className="sub">
       <div className="flexi">
       <SecondLucide name={props.image} style={{position:"relative",right:"20px"}}/>
       <h1>{props.heading}</h1>
       </div>
       <p>{props.comment}</p>
    </div>
  )
}
